import { OVERBURDEN_VIEW, OVERBURDEN_EDIT } from '@/fixtures'

export default {
  path: 'bup-overburden',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Overburden',
      component: () => import('@/views/menus/Overburden/Index'),
      meta: {
        permission: OVERBURDEN_VIEW
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Overburden',
      component: () => import('@/views/menus/Overburden/Detail'),
      meta: {
        permission: OVERBURDEN_VIEW,
        isEdit: false
      }
    },
    {
      path: ':id/edit',
      name: 'Edit Overburden',
      component: () => import('@/views/menus/Overburden/Detail'),
      meta: {
        permission: OVERBURDEN_EDIT,
        isEdit: true
      }
    }
  ]
}
